<template>
	<div class="feedback-page">
		<Head position="absolute" mode="white" :isHaveBack="true" @back="backHead"></Head>
		<div class="animate__animated animate__fadeInUp">
			<div class="body w1260">
				<div class="body-left">
					<div class="heading-1">意见反馈</div>
					<div class="heading-2">提意见、促优化，碳足迹服务因您更出色～</div>
					<div class="ul">
						<div class="li">
							<svg-icon name="checkbox-1"></svg-icon>
							<div class="text">反馈一次，优化一步，共推碳管理服务更贴合需求～</div>
						</div>
						<div class="li">
							<svg-icon name="checkbox-1"></svg-icon>
							<div class="text">汇聚行业声音，打造更懂你的碳足迹公共服务平台！</div>
						</div>
						<div class="li">
							<svg-icon name="checkbox-1"></svg-icon>
							<div class="text">您的真知灼见，让国际互认、跨领域覆盖更高效～</div>
						</div>
					</div>
				</div>
				<div class="body-right">
					<el-form key="form" :model="form" :rules="rules" ref="form" class="form">
						<el-form-item prop="name" class="name">
							<div class="label">您的姓名(*)</div>
							<div class="input-box">
								<el-input clearable v-model="form.name" placeholder=""></el-input>
							</div>
						</el-form-item>
						<el-form-item prop="phone" class="phone">
							<div class="label">您的手机号(*)</div>
							<div class="input-box">
								<el-input type="number" v-maxlength="11" clearable v-model="form.phone" placeholder=""></el-input>
							</div>
						</el-form-item>
						<el-form-item prop="cooperationItem" class="cooperationItem">
							<div class="label">问题描述(*)</div>
							<div class="textarea-box">
								<el-input type="textarea" clearable v-model="form.cooperationItem" placeholder=""></el-input>
							</div>
						</el-form-item>
					</el-form>
					<el-button class="submit" type="primary" @click="submit">提交</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { AddContactUs } from '@/common/api.js';
import Head from '@/layout/Head/Head.vue';
import Foot from '@/layout/Foot/Foot.vue';
export default {
	components: { Head, Foot },
	data() {
		// 手机号验证
		var validatePhone = (rule, value, callback) => {
			let result = this.verifyVal({ val: value, rules: ['phone'] });
			if (result.valid) {
				callback();
			} else {
				callback(new Error('手机号格式不正确'));
			}
		};
		return {
			form: {
				name: '', // 姓名
				phone: '', // 电话
				cooperationItem: '' // 合作事项
			},
			rules: {
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
				phone: [
					{ required: true, message: '请输入手机号', trigger: 'blur' },
					{ validator: validatePhone },
				],
				cooperationItem: [{ required: true, message: '请输入问题描述', trigger: 'blur' }]
			}
		};
	},
	created() {},
	mounted() {},
	methods: {
		backHead() {
			// this.$router.go(-1);
			// 检查是否有历史记录
			this.$router.back()
		},
		submit() {
			this.$refs.form.validate((valid) => {
				if (valid) {
					let data = {
						name: this.form.name,
						phone: this.form.phone,
						cooperationItem: this.form.cooperationItem
					};
					AddContactUs(data).then((res) => {
						this.toast({
							type: 'success',
							message: '提交成功'
						});
					});
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.feedback-page {
	display: flex;
	align-items: center;
	min-height: 100vh;
	position: relative;
	background: #29965c;
	background-image: url(~@/assets/tmp/045.png);
	background-position: left bottom;
	background-size: 100% 218px;
	background-repeat: no-repeat;
	padding: 60px 0;
	box-sizing: border-box;
	overflow: hidden;
	.body {
		display: flex;
		justify-content: space-between;
		.body-left {
			width: 474px;
			display: flex;
			flex-direction: column;
			padding-top: 55px;
			padding-bottom: 94px;
			.heading-1 {
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 42px;
				color: #ffffff;
				line-height: 59px;
			}
			.heading-2 {
				margin-top: 33px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 17px;
				color: #ffffff;
				line-height: 24px;
			}
			.ul {
				margin-top: auto;
				display: flex;
				flex-direction: column;
				.li {
					margin-top: 44px;
					display: flex;
					align-items: center;
					.svg-icon {
						margin-right: 12px;
						width: 20px;
						height: 20px;
					}
					.text {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 14px;
						color: #ffffff;
						line-height: 20px;
					}
				}
			}
		}
		.body-right {
			width: 721px;
			height: 486px;
			background: #ffffff;
			border-radius: 20px;
			display: flex;
			flex-direction: column;
			padding-top: 50px;
			padding-left: 45px;
			padding-right: 45px;
			padding-bottom: 64px;
			box-sizing: border-box;
			::v-deep {
				.form {
					display: flex;
					justify-content: space-between;
					flex-wrap: wrap;
					.el-form-item {
						.el-input .el-input__inner {
							border-color: transparent;
						}
						.el-input .el-input__inner:focus {
							border-color: $primary;
						}
						.el-textarea .el-textarea__inner {
							border-color: transparent;
						}
						.el-textarea .el-textarea__inner:focus {
							border-color: $primary;
						}
					}
					.el-form-item.is-error {
						.el-input .el-input__inner {
							border-color: #ec4242;
						}
						.el-input .el-input__inner:focus {
							border-color: #ec4242;
						}
						.el-textarea .el-textarea__inner {
							border-color: #ec4242;
						}
						.el-textarea .el-textarea__inner:focus {
							border-color: #ec4242;
						}
					}
					.name {
						display: flex;
						flex-direction: column;
						.label {
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 16px;
							color: #262729;
							line-height: 22px;
						}
						.input-box {
							margin-top: 20px;
							position: relative;
							display: flex;
							align-items: center;
							.el-input {
								.el-input__inner {
									height: 50px;
									border-radius: 10px;
									font-size: 16px;
									width: 275px;
									height: 50px;
									background: rgba(#e1ecf0, 0.5);
									&::placeholder {
										color: #9e9e9e;
									}
								}
								.el-input__icon {
									line-height: 50px;
								}
							}
							.prefix {
								left: 15px;
								position: absolute;
								font-size: 14px;
								color: #000000;
								line-height: 20px;
							}
						}
					}
					.phone {
						display: flex;
						flex-direction: column;
						.label {
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 16px;
							color: #262729;
							line-height: 22px;
						}
						.input-box {
							margin-top: 20px;
							position: relative;
							display: flex;
							align-items: center;
							.el-input {
								.el-input__inner {
									height: 50px;
									border-radius: 10px;
									font-size: 16px;
									width: 275px;
									height: 50px;
									background: rgba(#e1ecf0, 0.5);
									&::placeholder {
										color: #9e9e9e;
									}
								}
								.el-input__icon {
									line-height: 50px;
								}
							}
							.prefix {
								left: 15px;
								position: absolute;
								font-size: 14px;
								color: #000000;
								line-height: 20px;
							}
						}
					}
					.cooperationItem {
						margin-top: 23px;
						display: flex;
						flex-direction: column;
						width: 100%;
						.label {
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 16px;
							color: #262729;
							line-height: 22px;
						}
						.textarea-box {
							margin-top: 20px;
							position: relative;
							display: flex;
							align-items: center;
							.el-textarea {
								.el-textarea__inner {
									resize: unset;
									height: 122px;
									background: rgba(#e1ecf0, 0.5);
									border-radius: 10px;
								}
								.el-input__count {
									background: rgba(#e1ecf0, 0.5);
								}
							}
						}
					}
				}
			}
			.submit {
				align-self: center;
				margin-top: auto;
				display: flex;
				justify-content: center;
				align-items: center;
				border-radius: 56px;
				width: 408px;
				height: 56px;
				line-height: 56px;
				line-height: 24px;
			}
		}
	}
}
</style>
